/**
 * High-score persistente dos minigames.
 *
 * Storage: localStorage por game-id. Chave estável `slingu:highscore:<id>`.
 * Tolerante a privacy mode (todos os try/catch retornam fallback vazio).
 *
 * IDs usados (mantém alinhado com `App.tsx` e `docs/specs/minigames.md`):
 *   - 'flappy'
 *   - 'car-racer'
 *   - 'quiz-run'
 *   - 'word-match'
 *   - 'word-builder'
 *   - 'hangman'
 *   - 'word-mines'
 *   - 'word-slots'
 *   - 'word-search'
 *   - 'word-jumper'
 *
 * Uso típico num minigame:
 *   const best = getHighScore('flappy');                 // menu
 *   const { isNew, best } = commitScore('flappy', score); // over
 */

const PREFIX = 'slingu:highscore:';

export function getHighScore(id: string): number {
  try {
    const raw = localStorage.getItem(PREFIX + id);
    if (!raw) return 0;
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

/**
 * Grava o score se for maior que o recorde atual. Retorna se houve novo
 * recorde e o melhor valor final (após a operação).
 */
export function commitScore(
  id: string,
  score: number,
): { isNew: boolean; best: number } {
  const prev = getHighScore(id);
  if (score > prev) {
    try {
      localStorage.setItem(PREFIX + id, String(score));
    } catch {
      // privacy mode / quota — mantém em memória só pra esta sessão
    }
    return { isNew: true, best: score };
  }
  return { isNew: false, best: prev };
}

/** Admin/debug: zera um recorde específico. */
export function resetHighScore(id: string): void {
  try {
    localStorage.removeItem(PREFIX + id);
  } catch {
    // ignore
  }
}
